import { createAction } from "redux-starter-kit";

import { RESET_STEPS } from "../types";

const resetSteps = () => createAction(RESET_STEPS)();

export default resetSteps;
